import "core-js/modules/es.object.to-string.js";
import axios from 'axios';
import qs from 'qs';
import { readCookie } from '@/tools/tools';
axios.defaults.withCredentials = true;
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  // 设置超时
  timeout: 20000
});
// 请求拦截
service.interceptors.request.use(function (response) {
  var config = response;
  if (readCookie('accessToken')) {
    config.headers.common.accessToken = readCookie('accessToken');
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
// 响应拦截
service.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      // 本地的请求url
      case 403:
        window.location.href = '/login';
        break;
      case 401:
        window.location.href = '/login';
        break;
      case 502:
        window.location.href = '/login';
        break;
      default:
    }
  }
});
// get请求
export default {
  get: function get() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';
    return new Promise(function (resolve, reject) {
      service({
        url: url,
        method: method,
        params: params
      }).then(function (res) {
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  // post请求
  post: function post() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var headers = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function (resolve, reject) {
      service({
        url: url,
        data: headers.fileType ? params : qs.stringify(params),
        method: 'post',
        headers: headers
      }).then(function (res) {
        resolve(res);
      }).then(function (err) {
        reject(err);
      });
    });
  }
};